import { Box } from "@mui/material";
import NoDataBanner from "components/common/NoDataBanner";
import ActionBar from "../ActionBar";
import "./ConfigTabsData.scss";
interface props {
  dataList: any;
  type: any;
  tab: string;
  pagination: {};
  totalRecords: number;
  dateDetails?: boolean;
  showInncode?: boolean;
  showPlanDate?: boolean;
  noDataMessage?: string;
  shouldNavigate?: boolean;
  getUrl: (val: any) => string;
  navigateState?: any;
}

const TabsData = (props: any) => {
  const {
    dataList: list,
    type,
    tab,
    totalRecords,
    pagination,
    labelType,
    showInncode = false,
    dateDetails = false,
    showPlanDate = false,
    noDataMessage = "",
    shouldNavigate = false,
    getUrl,
    navigateState
  } = props;

  const fetchMore = () => {
    pagination?.setPageNo(pagination?.pageNo + 1);
  };

  return (
    <>
      {list?.length > 0 ? (
        <Box id="actionItemsDiv1" className="tabs-data-component">
          {list.map((element: any) => {
            return (
              <ActionBar
                type={type}
                tab={tab}
                dateDetails={dateDetails}
                showPlanDate={showPlanDate}
                showInncode={showInncode}
                element={element}
                url={getUrl(element)}
                shouldNavigate={shouldNavigate}
                navigateState={navigateState}
              />
            );
          })}
        </Box>
      ) : (
        <NoDataBanner noDataMessage={noDataMessage} />
      )}
    </>
  );
};
export default TabsData;
